import { useMemo } from "react";
import { Button, Spinner } from "@radix-ui/themes";
import { PlusIcon } from "@radix-ui/react-icons";
import { SelectOption } from "@/components/shared/select/Select";
import { DropdownMenu } from "@/components/shared/dropdown-menu";

interface AddTagButtonProps {
  options: SelectOption[];
  value?: string[];
  loading?: boolean;
  className?: string;
  onAdd: (value: SelectOption) => void;
}

export function AddTagButton({
  options,
  value,
  loading,
  className,
  onAdd,
}: AddTagButtonProps) {
  const availableOptions = useMemo<SelectOption[]>(() => {
    if (options == null) {
      return [];
    }

    const valueMap = new Set<string>(value ?? []);

    if (valueMap.size === 0) {
      return options ?? [];
    }

    return options.filter((option) => !valueMap.has(option.value));
  }, [value, options]);

  const items = useMemo(() => {
    return availableOptions.map((option) => ({
      label: option.label,
      onClick: () => onAdd(option),
    }));
  }, [availableOptions, onAdd]);

  if (!loading && availableOptions.length === 0) {
    return <></>;
  }

  return (
    <DropdownMenu items={items}>
      <DropdownMenu.Trigger>
        <Button
          color="gray"
          variant="ghost"
          highContrast
          size="1"
          className={className}
          disabled={loading}
        >
          <Spinner loading={loading}>
            <PlusIcon />
          </Spinner>
          Add Field
        </Button>
      </DropdownMenu.Trigger>
    </DropdownMenu>
  );
}
